import { APIHomeBinderData } from 'types/api.types';
import {
  HomeBinderSectionData,
  HomeUploadSummaryProcessedData,
} from './types';
import { processHomeBillingData } from './billingProcessor';
import { processHomeLocationsData } from './locationsProcessor';

export const processHomeUploadSummaryData = (
  binderData: APIHomeBinderData,
): HomeBinderSectionData<HomeUploadSummaryProcessedData> => {
  // Get the billing data
  const billingData = processHomeBillingData(binderData);

  // Get the locations data
  const locationsData = processHomeLocationsData(binderData);

  return {
    title: 'Upload Summary',
    description: 'Summary of billing and payment information.',
    isValid: true,
    message: null,
    data: {
      billing: billingData,
      locations: locationsData,
    },
  };
};
